import {requests} from "../../utils/helpers/api.services";
import {PROFILE_URL, USER_URL} from "../../utils/helpers/api.routes";
import {iChangePassword, User} from "../../model/user/User";

export const ProfileService = {
    getProfile:() => requests.get(PROFILE_URL),
    updateProfile: (id: number, body: User) => requests.put(`${USER_URL}/${id}`, body),
    changePassword: (body:iChangePassword)=> requests.put(`${PROFILE_URL}/change-password`,body)
}